import { CancellableTimeoutAlert } from '@planning/pages/GateClerk/Components/CancellableTimeoutAlert'
import { CheckOrderNotificationStore } from '@planning/rt-stores/tallyman/CheckOrderNotificationStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

interface IProps {
  store: CheckOrderNotificationStore
  onCancel: () => void
}

export const CheckSuccessAlert: FC<IProps> = observer(({ store, onCancel }) => {
  const { t } = useTranslate()

  const checkText = () => {
    if (store.isDirectRestow)
      return t('containerCheckedInAndOut', '{containerNumber} checked in and checked out', {
        containerNumber: store.order?.containerNumber,
      })

    if (store.order?.direction === 'Inbound')
      return t('containerCheckedIn', '{containerNumber} checked in', {
        containerNumber: store.order.containerNumber,
      })

    return t('containerCheckedOut', '{containerNumber} checked out', {
      containerNumber: store.order?.containerNumber,
    })
  }

  const cancelledText = () => {
    if (store.isDirectRestow)
      return t('containerCheckInAndOutCancelled', '{containerNumber} check in and out cancelled', {
        containerNumber: store.order?.containerNumber,
      })

    if (store.order?.direction === 'Inbound')
      return t('containerCheckInCancelled', '{containerNumber} check in cancelled', {
        containerNumber: store.order?.containerNumber,
      })

    return t('containerCheckOutCancelled', '{containerNumber} check out cancelled', {
      containerNumber: store.order?.containerNumber,
    })
  }

  const errorText = () => {
    if (store.isDirectRestow)
      return t('containerCheckInAndOutFailed', '{containerNumber} check in and out failed', {
        containerNumber: store.order?.containerNumber,
      })

    if (store.order?.direction === 'Inbound')
      return t('containerCheckInFailed', '{containerNumber} check in failed', {
        containerNumber: store.order?.containerNumber,
      })

    return t('containerCheckOutFailed', '{containerNumber} check out failed', {
      containerNumber: store.order?.containerNumber,
    })
  }

  return (
    <CancellableTimeoutAlert
      testId='check-success-alert'
      store={store}
      successText={checkText()}
      cancelledText={cancelledText()}
      errorText={errorText()}
      cancellable={store.cancellable}
      onCancel={onCancel}
    />
  )
})
